var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-tr',[_c('vs-td',{staticClass:"bg-white pt-10",attrs:{"colspan":_vm.colsCount}},[_c('p',{staticClass:"flex md:justify-center justify-start md:w-full w-1/4"},[_vm._v("\n      There are no data match your search\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }